import { supabase } from '../lib/supabase';

// Türkçe karakterleri temizle ve normalize et
function normalizeText(text: string): string {
  return text
    .replace(/İ/g, 'i')
    .toLowerCase()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/-/g, ' ')
    .trim();
}

export async function getCities() {
  const { data, error } = await supabase
    .from('cities')
    .select('*')
    .order('name');
  
  if (error) throw error;
  return data || [];
}

export async function getDistricts(citySlug: string) {
  try {
    // Slug'dan şehir adını normalize et
    const normalizedCityName = normalizeText(citySlug);

    // Şehri bul - case insensitive ve normalize edilmiş arama
    const { data: cities } = await supabase
      .from('cities')
      .select('*');
    
    // Şehri isim karşılaştırması yaparak bul
    const city = cities?.find(c => 
      normalizeText(c.name) === normalizedCityName
    );

    if (!city) return [];

    // İlçeleri getir
    const { data: districts } = await supabase
      .from('districts')
      .select(`
        *,
        city:cities (
          id,
          name
        )
      `)
      .eq('city_id', city.id)
      .order('name');

    return districts || [];

  } catch (err) {
    console.error('Error in getDistricts:', err);
    return [];
  }
}

export async function getNeighborhoods(citySlug: string, districtSlug: string) {
  try {
    // Slug'lardan isimleri normalize et
    const normalizedCityName = normalizeText(citySlug);
    const normalizedDistrictName = normalizeText(districtSlug);

    // Şehri bul
    const { data: cities } = await supabase
      .from('cities')
      .select('*');
    
    const city = cities?.find(c => 
      normalizeText(c.name) === normalizedCityName
    );

    if (!city) return [];

    // İlçeyi bul
    const { data: districts } = await supabase
      .from('districts')
      .select('*')
      .eq('city_id', city.id);
    
    const district = districts?.find(d => 
      normalizeText(d.name) === normalizedDistrictName
    );

    if (!district) return [];

    // Mahalleleri getir
    const { data: neighborhoods } = await supabase
      .from('neighborhoods')
      .select(`
        *,
        district:districts (
          *,
          city:cities (*)
        )
      `)
      .eq('district_id', district.id)
      .order('name');

    return neighborhoods || [];

  } catch (err) {
    console.error('Error in getNeighborhoods:', err);
    return [];
  }
}

export async function getTaxiStands(citySlug: string, districtSlug: string, neighborhoodSlug: string) {
  try {
    // Slug'lardan isimleri normalize et
    const normalizedCityName = normalizeText(citySlug);
    const normalizedDistrictName = normalizeText(districtSlug);
    const normalizedNeighborhoodName = normalizeText(neighborhoodSlug);

    // Şehri bul
    const { data: cities } = await supabase
      .from('cities')
      .select('*');
    
    const city = cities?.find(c => 
      normalizeText(c.name) === normalizedCityName
    );

    if (!city) return [];

    // İlçeyi bul
    const { data: districts } = await supabase
      .from('districts')
      .select('*')
      .eq('city_id', city.id);
    
    const district = districts?.find(d => 
      normalizeText(d.name) === normalizedDistrictName
    );

    if (!district) return [];

    // Mahalleyi bul
    const { data: neighborhoods } = await supabase
      .from('neighborhoods')
      .select('*')
      .eq('district_id', district.id);
    
    const neighborhood = neighborhoods?.find(n => 
      normalizeText(n.name) === normalizedNeighborhoodName
    );

    if (!neighborhood) return [];

    // Taksi duraklarını getir
    const { data: taxiStands } = await supabase
      .from('taxi_stands')
      .select(`
        *,
        neighborhood:neighborhoods (
          *,
          district:districts (
            *,
            city:cities (*)
          )
        )
      `)
      .eq('neighborhood_id', neighborhood.id)
      .eq('is_verified', true)
      .order('name');

    return taxiStands || [];

  } catch (err) {
    console.error('Error in getTaxiStands:', err);
    return [];
  }
}